import { LocDefs, LocMap } from '@cm/core/localization';
import { pathStart, sharedProperties } from '../../models/score-report-delay-locs';

export type SPSettingsScoreReportDelayAddLocNames =
	| 'SPSettingsScoreReportDelayAddTitle'
	| 'SPSettingsScoreReportDelayAddConfirm'
	| 'SPSettingsScoreReportDelayAddCancel';

export const spSettingsScoreReportDelayAddLocs: LocDefs<SPSettingsScoreReportDelayAddLocNames> = {
	SPSettingsScoreReportDelayAddTitle: {
		defaultValue: 'Add Delay Setting',
		description: 'Title for the score report delay add setting dialog.',
		displayPath: `${pathStart}Add Dialog Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayAddConfirm: {
		defaultValue: 'Add Delay Setting',
		description: 'Confirm button for the score report delay add setting dialog.',
		displayPath: `${pathStart}Add Dialog|Confirm`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPSettingsScoreReportDelayAddCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button for the score report delay add setting dialog.',
		displayPath: `${pathStart}Add Dialog|Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPSettingsScoreReportDelayAddLocType = LocMap<SPSettingsScoreReportDelayAddLocNames>;
